export default () => ({
  componentName: 'cell-icon-renderer',
});
